function _decorate(decorators, factory, superClass, mixins) { var api = _getDecoratorsApi(); if (mixins) { for (var i = 0; i < mixins.length; i++) { api = mixins[i](api); } } var r = factory(function initialize(O) { api.initializeInstanceElements(O, decorated.elements); }, superClass); var decorated = api.decorateClass(_coalesceClassElements(r.d.map(_createElementDescriptor)), decorators); api.initializeClassElements(r.F, decorated.elements); return api.runClassFinishers(r.F, decorated.finishers); }

function _getDecoratorsApi() { _getDecoratorsApi = function () { return api; }; var api = { elementsDefinitionOrder: [["method"], ["field"]], initializeInstanceElements: function (O, elements) { ["method", "field"].forEach(function (kind) { elements.forEach(function (element) { if (element.kind === kind && element.placement === "own") { this.defineClassElement(O, element); } }, this); }, this); }, initializeClassElements: function (F, elements) { var proto = F.prototype; ["method", "field"].forEach(function (kind) { elements.forEach(function (element) { var placement = element.placement; if (element.kind === kind && (placement === "static" || placement === "prototype")) { var receiver = placement === "static" ? F : proto; this.defineClassElement(receiver, element); } }, this); }, this); }, defineClassElement: function (receiver, element) { var descriptor = element.descriptor; if (element.kind === "field") { var initializer = element.initializer; descriptor = { enumerable: descriptor.enumerable, writable: descriptor.writable, configurable: descriptor.configurable, value: initializer === void 0 ? void 0 : initializer.call(receiver) }; } Object.defineProperty(receiver, element.key, descriptor); }, decorateClass: function (elements, decorators) { var newElements = []; var finishers = []; var placements = { static: [], prototype: [], own: [] }; elements.forEach(function (element) { this.addElementPlacement(element, placements); }, this); elements.forEach(function (element) { if (!_hasDecorators(element)) return newElements.push(element); var elementFinishersExtras = this.decorateElement(element, placements); newElements.push(elementFinishersExtras.element); newElements.push.apply(newElements, elementFinishersExtras.extras); finishers.push.apply(finishers, elementFinishersExtras.finishers); }, this); if (!decorators) { return { elements: newElements, finishers: finishers }; } var result = this.decorateConstructor(newElements, decorators); finishers.push.apply(finishers, result.finishers); result.finishers = finishers; return result; }, addElementPlacement: function (element, placements, silent) { var keys = placements[element.placement]; if (!silent && keys.indexOf(element.key) !== -1) { throw new TypeError("Duplicated element (" + element.key + ")"); } keys.push(element.key); }, decorateElement: function (element, placements) { var extras = []; var finishers = []; for (var decorators = element.decorators, i = decorators.length - 1; i >= 0; i--) { var keys = placements[element.placement]; keys.splice(keys.indexOf(element.key), 1); var elementObject = this.fromElementDescriptor(element); var elementFinisherExtras = this.toElementFinisherExtras((0, decorators[i])(elementObject) || elementObject); element = elementFinisherExtras.element; this.addElementPlacement(element, placements); if (elementFinisherExtras.finisher) { finishers.push(elementFinisherExtras.finisher); } var newExtras = elementFinisherExtras.extras; if (newExtras) { for (var j = 0; j < newExtras.length; j++) { this.addElementPlacement(newExtras[j], placements); } extras.push.apply(extras, newExtras); } } return { element: element, finishers: finishers, extras: extras }; }, decorateConstructor: function (elements, decorators) { var finishers = []; for (var i = decorators.length - 1; i >= 0; i--) { var obj = this.fromClassDescriptor(elements); var elementsAndFinisher = this.toClassDescriptor((0, decorators[i])(obj) || obj); if (elementsAndFinisher.finisher !== undefined) { finishers.push(elementsAndFinisher.finisher); } if (elementsAndFinisher.elements !== undefined) { elements = elementsAndFinisher.elements; for (var j = 0; j < elements.length - 1; j++) { for (var k = j + 1; k < elements.length; k++) { if (elements[j].key === elements[k].key && elements[j].placement === elements[k].placement) { throw new TypeError("Duplicated element (" + elements[j].key + ")"); } } } } } return { elements: elements, finishers: finishers }; }, fromElementDescriptor: function (element) { var obj = { kind: element.kind, key: element.key, placement: element.placement, descriptor: element.descriptor }; var desc = { value: "Descriptor", configurable: true }; Object.defineProperty(obj, Symbol.toStringTag, desc); if (element.kind === "field") obj.initializer = element.initializer; return obj; }, toElementDescriptors: function (elementObjects) { if (elementObjects === undefined) return; return _toArray(elementObjects).map(function (elementObject) { var element = this.toElementDescriptor(elementObject); this.disallowProperty(elementObject, "finisher", "An element descriptor"); this.disallowProperty(elementObject, "extras", "An element descriptor"); return element; }, this); }, toElementDescriptor: function (elementObject) { var kind = String(elementObject.kind); if (kind !== "method" && kind !== "field") { throw new TypeError('An element descriptor\'s .kind property must be either "method" or' + ' "field", but a decorator created an element descriptor with' + ' .kind "' + kind + '"'); } var key = _toPropertyKey(elementObject.key); var placement = String(elementObject.placement); if (placement !== "static" && placement !== "prototype" && placement !== "own") { throw new TypeError('An element descriptor\'s .placement property must be one of "static",' + ' "prototype" or "own", but a decorator created an element descriptor' + ' with .placement "' + placement + '"'); } var descriptor = elementObject.descriptor; this.disallowProperty(elementObject, "elements", "An element descriptor"); var element = { kind: kind, key: key, placement: placement, descriptor: Object.assign({}, descriptor) }; if (kind !== "field") { this.disallowProperty(elementObject, "initializer", "A method descriptor"); } else { this.disallowProperty(descriptor, "get", "The property descriptor of a field descriptor"); this.disallowProperty(descriptor, "set", "The property descriptor of a field descriptor"); this.disallowProperty(descriptor, "value", "The property descriptor of a field descriptor"); element.initializer = elementObject.initializer; } return element; }, toElementFinisherExtras: function (elementObject) { var element = this.toElementDescriptor(elementObject); var finisher = _optionalCallableProperty(elementObject, "finisher"); var extras = this.toElementDescriptors(elementObject.extras); return { element: element, finisher: finisher, extras: extras }; }, fromClassDescriptor: function (elements) { var obj = { kind: "class", elements: elements.map(this.fromElementDescriptor, this) }; var desc = { value: "Descriptor", configurable: true }; Object.defineProperty(obj, Symbol.toStringTag, desc); return obj; }, toClassDescriptor: function (obj) { var kind = String(obj.kind); if (kind !== "class") { throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator' + ' created a class descriptor with .kind "' + kind + '"'); } this.disallowProperty(obj, "key", "A class descriptor"); this.disallowProperty(obj, "placement", "A class descriptor"); this.disallowProperty(obj, "descriptor", "A class descriptor"); this.disallowProperty(obj, "initializer", "A class descriptor"); this.disallowProperty(obj, "extras", "A class descriptor"); var finisher = _optionalCallableProperty(obj, "finisher"); var elements = this.toElementDescriptors(obj.elements); return { elements: elements, finisher: finisher }; }, runClassFinishers: function (constructor, finishers) { for (var i = 0; i < finishers.length; i++) { var newConstructor = (0, finishers[i])(constructor); if (newConstructor !== undefined) { if (typeof newConstructor !== "function") { throw new TypeError("Finishers must return a constructor."); } constructor = newConstructor; } } return constructor; }, disallowProperty: function (obj, name, objectType) { if (obj[name] !== undefined) { throw new TypeError(objectType + " can't have a ." + name + " property."); } } }; return api; }

function _createElementDescriptor(def) { var key = _toPropertyKey(def.key); var descriptor; if (def.kind === "method") { descriptor = { value: def.value, writable: true, configurable: true, enumerable: false }; } else if (def.kind === "get") { descriptor = { get: def.value, configurable: true, enumerable: false }; } else if (def.kind === "set") { descriptor = { set: def.value, configurable: true, enumerable: false }; } else if (def.kind === "field") { descriptor = { configurable: true, writable: true, enumerable: true }; } var element = { kind: def.kind === "field" ? "field" : "method", key: key, placement: def.static ? "static" : def.kind === "field" ? "own" : "prototype", descriptor: descriptor }; if (def.decorators) element.decorators = def.decorators; if (def.kind === "field") element.initializer = def.value; return element; }

function _coalesceGetterSetter(element, other) { if (element.descriptor.get !== undefined) { other.descriptor.get = element.descriptor.get; } else { other.descriptor.set = element.descriptor.set; } }

function _coalesceClassElements(elements) { var newElements = []; var isSameElement = function (other) { return other.kind === "method" && other.key === element.key && other.placement === element.placement; }; for (var i = 0; i < elements.length; i++) { var element = elements[i]; var other; if (element.kind === "method" && (other = newElements.find(isSameElement))) { if (_isDataDescriptor(element.descriptor) || _isDataDescriptor(other.descriptor)) { if (_hasDecorators(element) || _hasDecorators(other)) { throw new ReferenceError("Duplicated methods (" + element.key + ") can't be decorated."); } other.descriptor = element.descriptor; } else { if (_hasDecorators(element)) { if (_hasDecorators(other)) { throw new ReferenceError("Decorators can't be placed on different accessors with for " + "the same property (" + element.key + ")."); } other.decorators = element.decorators; } _coalesceGetterSetter(element, other); } } else { newElements.push(element); } } return newElements; }

function _hasDecorators(element) { return element.decorators && element.decorators.length; }

function _isDataDescriptor(desc) { return desc !== undefined && !(desc.value === undefined && desc.writable === undefined); }

function _optionalCallableProperty(obj, name) { var value = obj[name]; if (value !== undefined && typeof value !== "function") { throw new TypeError("Expected '" + name + "' to be a function"); } return value; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { html, LitElement, property } from '../../../_snowpack/pkg/lit-element.js';
import { outlet } from '../../../_snowpack/pkg/eagrouter.js';
import { SubSink } from '../../../_snowpack/pkg/subsink.js';
import { userCart$, fireAuthState, getCategories, language$, changeLanguage, signInUsers, registerEmailandPassword, updateDetailsafterSignup, userlogout } from '../../server/firebase.config.js';
import { firestoreFacade } from '../../server/firestore.facades.js';
import { tap, map } from '../../../_snowpack/pkg/rxjs/operators.js';
import '../../auth/login.js';

let home = _decorate(null, function (_initialize, _LitElement) {
  class home extends _LitElement {
    constructor(...args) {
      super(...args);

      _initialize(this);
    }

  }

  return {
    F: home,
    d: [{
      kind: "method",
      key: "createRenderRoot",
      value: function createRenderRoot() {
        return this;
      }
    }, {
      kind: "field",
      key: "cart$",

      value() {
        return userCart$.pipe(tap(item => {
          // console.log(item)
          item?.products ? this.cartProducts = item?.products : [];
        }));
      }

    }, {
      kind: "field",
      decorators: [property()],
      key: "cartProducts",

      value() {
        return [];
      }

    }, {
      kind: "method",
      key: "blurEvent",
      value: function blurEvent(event, amount, textContent) {
        // alert('i bluredd')
        const formParent = event.target.parentNode;
        const errorSpan = formParent.querySelector('.error'); // console.log(event.target.value)

        if (event.target.value.length < amount) {
          errorSpan.textContent = textContent;
          errorSpan.style = 'display: block';
          formParent.classList.add('hasError');
        } else {
          errorSpan.textContent = '';
          errorSpan.style = 'display: none';
          formParent.classList.remove('hasError');
        }

        const label = formParent.querySelector('label');
        label.classList.remove('active');
      }
    }, {
      kind: "method",
      key: "focusEvent",
      value: function focusEvent(event) {
        const formParent = event.target.parentNode;
        const label = formParent.querySelector('label');
        label.classList.add('active');
      }
    }, {
      kind: "method",
      key: "login",
      value: async function login(event) {
        event.preventDefault(); // alert(event.target.value)
        // return

        const values = Array.from(event.target.elements).map(item => ({
          name: item.name,
          value: item.value
        }));
        values.pop();
        const valueFields = {};

        for (const items in values) {
          const {
            name,
            value
          } = values[items];
          valueFields[name] = value;
        } // console.log(valueFields);
        // return


        try {
          const userLogin = await signInUsers(valueFields.email, valueFields.password);

          if (userLogin) {
            outlet('home'); // alert("worked!")
          }
        } catch (error2) {
          // console.error(error2);
          if (error2.code === 'auth/wrong-email') {
            alert('Invalid Email');
          }

          if (error2.code === 'auth/wrong-password') {
            alert('Invalid Password');
          }

          if (error2.code === 'auth/user-not-found') {
            alert('User Not found');
          }
        }
      }
    }, {
      kind: "method",
      key: "signup",
      value: async function signup(event) {
        event.preventDefault();
        const values = Array.from(event.target.elements).map(item => ({
          name: item.name,
          value: item.value
        }));
        values.pop();
        values.pop();
        const valueField = {};

        for (const items in values) {
          const {
            name,
            value
          } = values[items];
          valueField[name] = value;
        } // console.log(valueField);
        // return


        try {
          const user = await registerEmailandPassword(valueField.email, valueField.password); // await user.user.sendEmailVerification();

          await user.user.updateProfile({
            displayName: `${valueField.cname} ${valueField.cnip}`
          });
          await updateDetailsafterSignup(user.user.uid, valueField.cname, valueField.cnip, valueField.phone, user.user.email);
          alert('Zostałeś Ponyślnie Zalogowany');
          outlet('home');
        } catch (error) {// console.error(error);
          // if (error.code === 'auth/email-already-in-use') {
          //   alert('Ten adres e-mail został już zarejestrowany');
          // }
        }
      }
    }, {
      kind: "method",
      key: "mobileMenuOpen",
      value: function mobileMenuOpen() {
        document.querySelector('.m-menu_menu').style.display = 'block'; // document.querySelector('.close').style.display = 'block';
        // document.querySelector('.menu-right').style.display = 'block';
      }
    }, {
      kind: "method",
      key: "mobileMenuClose",
      value: function mobileMenuClose() {
        document.querySelector('.m-menu_menu').style.display = 'none'; // document.querySelector('.open').style.display = 'block';
        // document.querySelector('.menu-right').style.display = 'none';
      }
    }, {
      kind: "method",
      key: "submenu",
      value: function submenu() {
        document.querySelector('.sub_m').style.display = 'block';
        document.querySelector('.m-menu_ul').style.display = 'none';
      }
    }, {
      kind: "method",
      key: "submenuclose",
      value: function submenuclose() {
        document.querySelector('.sub_m').style.display = 'none';
        document.querySelector('.m-menu_ul').style.display = 'block';
      }
    }, {
      kind: "method",
      key: "openlang",
      value: function openlang() {
        document.querySelector('.lang_menu').style.display = 'block';
      }
    }, {
      kind: "method",
      key: "openprofile",
      value: function openprofile() {
        document.querySelector('.profile_menu').style.display = 'block';
      }
    }, {
      kind: "method",
      key: "closeprofile",
      value: function closeprofile() {
        document.querySelector('.profile_menu').style.display = 'none';
      }
    }, {
      kind: "method",
      key: "opendropmenu",
      value: function opendropmenu() {
        document.querySelector('.main_sub_menu').style.display = 'block';
      }
    }, {
      kind: "method",
      key: "closedropmenu",
      value: function closedropmenu() {
        document.querySelector('.main_sub_menu').style.display = 'none';
      }
    }, {
      kind: "method",
      key: "displaySub",
      value: function displaySub() {
        document.querySelector('.product-menu-list').style.display = 'block';
      }
    }, {
      kind: "field",
      key: "subs",

      value() {
        return new SubSink();
      }

    }, {
      kind: "field",
      key: "categories$",

      value() {
        return getCategories().pipe(map(cat => {
          const catRanking = {
            moduły: 1,
            inwertery: 2,
            'elementy montażowe': 3,
            'śruby - wkręty': 4,
            haki: 5,
            akcesoria: 6,
            'mikro - inwertery': 7
          };

          const keysorter = (a, b) => {
            const nameA = catRanking[a]; // console.log({ nameA, a });

            const nameB = catRanking[b];

            if (nameA < nameB) {
              return -1;
            }

            if (nameA > nameB) {
              return 1;
            }

            return 0;
          };

          cat.sort((a, b) => keysorter(a.categoryName.toLowerCase(), b.categoryName.toLowerCase()));
          return cat;
        }), tap(theCategories => {
          this.categories = theCategories;
        }));
      }

    }, {
      kind: "field",
      decorators: [property()],
      key: "categories",

      value() {
        return [];
      }

    }, {
      kind: "field",
      decorators: [property()],
      key: "language",

      value() {
        return '';
      }

    }, {
      kind: "field",
      decorators: [property()],
      key: "authState",

      value() {
        return false;
      }

    }, {
      kind: "method",
      key: "closeModal",
      value: function closeModal() {
        document.querySelector('#closeCart').click();
      }
    }, {
      kind: "method",
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(home.prototype), "connectedCallback", this).call(this);

        this.cart$.subscribe();
        this.subs.sink = this.categories$.subscribe();
        this.subs.sink = language$.subscribe(lan => {
          this.language = lan;
        });
        this.subs.sink = fireAuthState.subscribe(user => {
          // alert(this.authState)
          if (user) {
            this.authState = true;
          } else {
            this.authState = false;
          }
        }); // fireAuthState.subscribe();
      } // changeLan(lan) {
      //   changeLanguage(lan.target.value);
      // }

    }, {
      kind: "method",
      key: "pl",
      value: function pl() {
        changeLanguage('PL');
        document.querySelector('.lang_menu').style.display = 'none';
      }
    }, {
      kind: "method",
      key: "en",
      value: function en() {
        changeLanguage('EN');
        document.querySelector('.lang_menu').style.display = 'none';
      }
    }, {
      kind: "method",
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(home.prototype), "disconnectedCallback", this).call(this);

        this.subs.unsubscribe(); // this.cart$.unsubscribe();
      }
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        return html` 
       <div class="header">
        <div class="header_col1">
          <a href="/">
          <img src="images/xdisc.png" />
          </a>
        </div>

        <div class="header_col2">
          <ul class="header_col2_menu">
            <li class="header_col2_menulist">
               <a @mouseenter=${this.opendropmenu} @mouseleave=${this.closedropmenu} style="cursor:pointer;"> ${this.language === 'PL' ? 'Produkty' : 'Products'} </a>
              <ul class="menu main_sub_menu" @mouseenter=${this.opendropmenu} @mouseleave=${this.closedropmenu}>
              ${this.categories.map(item => html`
                  <li class="menulist">
                    <a
                      href=${`/product?id=${item.categoryName}`}
                      style="text-transform: uppercase;"
                      @click=${this.closedropmenu}
                    >
                      &nbsp; &nbsp;
                      ${this.language === 'PL' ? `${item.categoryName}` : `${item.categoryNameEng}`}
                    </a>
                  </li>
                `)}
              </ul>
            </li>
            <li class="header_col2_menulist "><a href="/sales">${this.language === 'PL' ? 'Promocje' : 'Sales'}</a></li>
            <li class="header_col2_menulist"><a href="/new">
                ${this.language === 'PL' ? 'Nowości' : 'New Arrivals'}
              </a></li>
            <li class="header_col2_menulist"><a href="/about">
                ${this.language === 'PL' ? 'O Nas' : 'About'}
              </a></li>
            <li class="header_col2_menulist"><a href="/contact">
                ${this.language === 'PL' ? 'Kontakt' : 'Contact'}
              </a></li>
          </ul>
        </div>

        <div class="header_col3">

        ${this.authState === true ? html`
                <ul class="header_col3_menu">
                  <li class="header_col3_menulist">
                    <a href="tel: 48697007115">
                      <i class="fa fa-phone icons"> </i>
                    </a>
                  </li>
                  <li class="header_col3_menulist">
                    <a @click=${this.openlang} style="cursor:pointer;"
                      >${this.language}</a
                    >

                    <ul class="menu lang_menu">
                      <li class="menulist">
                        <a @click=${this.pl}>
                          <img
                            src="https://firebasestorage.googleapis.com/v0/b/xdisc-cd76a.appspot.com/o/images%2F255px-Flag_of_Poland.svg.png?alt=media&token=1676ef3e-2ea5-4b48-b0bc-ad5425e6a4de"
                            height="30px"
                            width="30px"
                          />
                          PL
                        </a>
                      </li>
                      <li class="menulist">
                        <a @click=${this.en}>
                          <img
                            src="https://firebasestorage.googleapis.com/v0/b/xdisc-cd76a.appspot.com/o/images%2Fdownload.png?alt=media&token=dabd84eb-347d-4f8e-b82a-1b608f221c98"
                            height="30px"
                            width="30px"
                          />
                          En
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    class="header_col3_menulist"
                    data-toggle="modal"
                    data-target="#cart"
                  >
                    <a href="">
                      <i class="fa fa-shopping-cart icons"></i
                      ><small class="cart_num"
                        >${this.cartProducts.length}</small
                      >
                    </a>
                  </li>
                  <li class="header_col3_menulist">
                    <a
                      @mouseenter=${this.openprofile}
                      @mouseleave=${this.closeprofile}
                      style="cursor:pointer;"
                    >
                      <i class="fa fa-user icons"></i>
                    </a>

                    <ul
                      class="profilemenu profile_menu"
                      @mouseenter=${this.openprofile}
                      @mouseleave=${this.closeprofile}
                    >
                      <li class="profile_menulist" @click=${this.closeprofile}>
                        <a
                          @click=${() => {
          outlet('my-profile');
        }}
                        >
                          Profile
                        </a>
                      </li>

                      <li class="profile_menulist" @click=${this.closeprofile}>
                        <a
                          @click=${() => {
          userlogout();
          outlet('home');
        }}
                        >
                          Logout
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              ` : html`
                <ul class="header_col3_menu">
                  <li class="header_col3_menulist">
                    <a
                      href=""
                      data-toggle="modal"
                      data-target="#auth"
                      class="login-btn"
                    >
                      ${this.language === 'PL' ? 'Zaloguj się' : 'Login'}
                    </a>
                  </li>

                  <li class="header_col3_menulist">
                    <a
                      href=""
                      data-toggle="modal"
                      data-target="#signUpauth"
                      class="register-btn"
                    >
                      ${this.language === 'PL' ? 'Zarejestruj się' : 'Register'}
                    </a>
                  </li>
                </ul>
              `}
        </div>
        <!-- </div> -->

        <div class="header_col4">
        <div class="bar_icon" data-toggle="modal"
                    data-target="#cart">
                    <a href="">
                      <i class="fa fa-shopping-cart icons"></i
                      ><small class="cart_num"
                        >${this.cartProducts.length}</small
                      >
                    </a>
      </div>

      <a class="bar_icon"  @click=${() => {
          outlet('my-profile');
        }} >
                          <i class="fa fa-user icons"></i>
                        </a>


        <i class="fa fa-bars icons bar_icon" @click=${this.mobileMenuOpen}></i>
        
          <div class="m-menu">
            


            <div class="m-menu_menu">
            <div class="close_btn">
              <i class="fa fa-remove" @click=${this.mobileMenuClose}></i>
            </div>
            <ul class="m-menu_ul">
              <li class="m-menu_menulist">
                
                <a @click=${this.submenu}> Produkty</a> 
               

              </li>

              <li class="m-menu_menulist">
                <a href="/sales">
                  Promocje
                </a>

              </li>

              <li class="m-menu_menulist">
                <a href="/product?id=new">
                  Nowości
                </a>

              </li>

              <li class="m-menu_menulist">
                <a href="/about">
                  O Nas
                </a>

              </li>

              <li class="m-menu_menulist">
                <a href="/contact">
                  Kontakt
                </a>

              </li>
            </ul>

            <ul class=" sub_m">
              <div class="" style="float:right; padding-right:10px;">

              <i class="fa fa-arrow-left" @click=${this.submenuclose}></i>

              </div>

              ${this.categories.map(item => html`
                  <li class="m-menu_menulist">
                    <a href=${`/product?id=${item.categoryName}`}>
                      ${this.language === 'PL' ? `${item.categoryName}` : `${item.categoryNameEng}`}
                    </a>
                  </li>
                `)}
            </ul>
            </div>
          </div>
        </div>


      </div>















	 <!-- Modal -->
	 <div class="modal fade" id="cart" role="dialog">
    <div class="modal-dialog">
    
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeCart" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title"> ${this.language === 'PL' ? 'Wózek' : 'Cart'}
          </h4>
        </div>
        <div class="modal-body">


		      <table class="carttable">
            

            ${this.cartProducts?.map((item, index) => html`
                <tr>
                  <td>
                    <img
                      src=${item.cartImage}
                      style="width:100px; height:100px;"
                    />
                  </td>
                  <td>${item.name}</td>
                  <td>${item.price}</td>
                  <td>${item.variant.name}</td>
                  <td>
                    <button
                      @click=${() => firestoreFacade.incrementItem(index)}
                      class="btn btn-primary"
                      style="color: white !important"
                    >
                      +
                    </button>
                    <span style="font-size:30px"> ${item.quantity} </span>
                    <button
                      @click=${() => firestoreFacade.decrementCount(index)}
                      class="btn btn-primary"
                      style="color: white !important"
                      .disabled=${item.quantity === 1}
                    >
                      -
                    </button>
                  </td>

                  <td>
                    <button
                      class="mdc-icon-button material-icons"
                      style="color: #b00020"
                      @click=${() => firestoreFacade.removeItemFromCart(index)}
                    >
                      ${this.language === 'PL' ? 'Usuń' : 'delete'}
                    </button>
                  </td>
                </tr>
              `)}
  
          </table>


        </div>
        <div class="modal-footer">
          <a href="/checkout"  >
          <button type="button" @click=${this.closeModal}    class="btn btn-default" > ${this.language === 'PL' ? 'Kupuję' : 'Checkout'}</button>
        </div>
        </a>
      </div>

      
    </div>
  </div>




   <!-- Modal -->
	 <div class="modal fade" id="auth" role="dialog">
    <div class="modal-dialog">
    
      <!-- Modal content-->
      <div class="modal-content">
        
        <div class="modal-body" style="text-align: center;">

          <!-- Form- start -->

          <form style="width:50%; display: inline-block; " @submit=${this.login}>

          <div class="form-body">
          <label for="email">Email</label>
          <input type="text" class="form-control email" name="email" id="email"  @focus=${this.focusEvent} @blur=${event => {
          this.blurEvent(event, 6, `${this.language === 'PL' ? 'Proszę wpisz email' : 'Please type your email address'}`);
        }}>
          <span class="error"></span>
          </div>

          <div class="form-body">
          <label for="pass"> ${this.language === 'PL' ? 'Hasło' : 'Password'} </label>
          <input type="password" class="form-control pass" name="password" id="pass" @focus=${this.focusEvent} @blur=${event => {
          this.blurEvent(event, 6, `${this.language === 'PL' ? 'Proszę wpisz hasło' : 'Please type your password'}`);
        }}>
          <span class="error"></span>
          </div>
          <br>

          
          <input type="submit" class="form-control btn btn-primary"  placeholder=${this.language === 'PL' ? 'Dodaj' : 'Submit'} >
          </div>

          </form>

          

          <!-- Form Ends -->


        </div>
        
        
      </div>

      
    </div>
  </div>




  <!-- Modal -->
  <div class="modal fade" id="signUpauth"  role="dialog" @submit=${this.signup}>
    <div class="modal-dialog">
    
      <!-- Modal content-->
      <div class="modal-content">
        
        <div class="modal-body" style="text-align: center;">

          <!-- Form- start -->

          <form style="width:50%; display: inline-block; " @submit=${this.signup}>

          <div class="form-body">
          <label for="email">Email</label>
          <input type="text" class="form-control email" name="email" id="email"  @focus=${this.focusEvent} @blur=${event => {
          this.blurEvent(event, 6, 'Please type your email address');
        }}>
          <span class="error"></span>
          </div>

          <div class="form-body">
          <label for="phone">Phone Number</label>
          <input type="text" class="form-control phone" name="phone" id="phone"  @focus=${this.focusEvent} @blur=${event => {
          this.blurEvent(event, 6, 'Please type your phone number');
        }}>
          <span class="error"></span>
          </div>


          <div class="form-body">
          <label for="cname">Company Name</label>
          <input type="text" class="form-control cname" name="cname" id="cname"  @focus=${this.focusEvent} @blur=${event => {
          this.blurEvent(event, 6, 'Please type your company name');
        }}>
          <span class="error"></span>
          </div>


          <div class="form-body">
          <label for="cnip">Company Nip</label>
          <input type="text" class="form-control cnip" name="cnip" id="cnip"  @focus=${this.focusEvent} @blur=${event => {
          this.blurEvent(event, 6, 'Please type your company nip');
        }}>
          <span class="error"></span>
          </div>

          <div class="form-body">
          <label for="password">Password</label>
          <input type="password" class="form-control password" name="password" id="password" @focus=${this.focusEvent} @blur=${event => {
          this.blurEvent(event, 6, 'Please type your password');
        }}>
          <span class="error"></span>
          </div>

          <div class="form-body">
          <label for="passwordCon">Password</label>
          <input type="password" class="form-control passwordCon"  id="passwordCon" @focus=${this.focusEvent} @blur=${event => {
          this.blurEvent(event, 6, 'Please type your password again');
        }}>
          <span class="error"></span>
          </div>
          <br>

          
          <input type="submit" class="form-control btn btn-primary"  placeholder="Submit" id="pass">
          </div>

          </form>

          

          <!-- Form Ends -->


        </div>
        
        
      </div>

      
    </div>
  </div>


<style>
.error{
  color: #f95959;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  /* position: absolute;
  bottom: -20px; */
  right: 0;
  display: none;
}
</style>

  

        `;
      }
    }]
  };
}, LitElement);

customElements.define('header-area', home);